var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bg-overlay"}},[_c('Header'),_c('Sidebar'),_c('v-main',{attrs:{"app":""}},[_c('v-container',{staticClass:"px-3 px-sm-6",attrs:{"fluid":""}},[_c('router-view'),_c('v-sheet',{attrs:{"color":"transparent","height":`calc(${_vm.footerHeight} + 40px)`}})],1),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }